import { Injectable } from '@angular/core';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { ContactPerson } from '../../interfaces/lead-form/contact-person';

@Injectable({
  providedIn: 'root'
})
export class LeadFormContactToTableDataMapperService {

  constructor() { }

  public map(contactPerson: ContactPerson): DialogTableDataRow[] {
    return [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'TITLE',
        i18nValueKey: contactPerson.title,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'FIRSTNAME',
        value: contactPerson.firstName,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'LASTNAME',
        value: contactPerson.lastName,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'EMAILADDRESS',
        value: contactPerson.email,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PHONE',
        value: contactPerson.phone,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'CONTACTPREFERENCE',
        i18nValueKey: contactPerson.contactPreference,
      },
    ];
  }
}
